import { createContext, useContext, useReducer, useEffect } from 'react'
import PropTypes from 'prop-types'
import Cookies from 'js-cookie'

const CartContext = createContext()

const initialState = Cookies.get('cart') ? JSON.parse(Cookies.get('cart')) : []

const cartReducer = (state, action) => {
  switch (action.type) {
    case 'ADD_ITEM': {
      const existingItem = state.find(item => item.id === action.payload.id)
      if (existingItem) {
        return state.map(item =>
          item.id === action.payload.id
            ? { ...item, quantity: item.quantity + 1 }
            : item
        )
      } else {
        return [...state, { ...action.payload, quantity: 1 }]
      }
    }
    case 'REMOVE_ITEM':
      return state.filter(item => item.id !== action.payload.id)
    case 'CLEAR_CART':
      return []
    case 'UPDATE_QUANTITY':
      return state.map(item =>
        item.id === action.payload.productId ? { ...item, quantity: action.payload.quantity } : item
      )
    default:
      return state
  }
}

export const CartProvider = ({ children }) => {
  const [cart, dispatch] = useReducer(cartReducer, initialState)

  useEffect(() => {
    Cookies.set('cart', JSON.stringify(cart), { 
          expires: 7,
          sameSite: 'None',
          secure: true
        })
  }, [cart])

  const addToCart = item => { dispatch({ type: 'ADD_ITEM', payload: item }) }
  const removeFromCart = id => { dispatch({ type: 'REMOVE_ITEM', payload: { id } }) }
  const clearCart = () => { dispatch({ type: 'CLEAR_CART' }) }
  const updateQuantity = (productId, quantity) => { dispatch({ type: 'UPDATE_QUANTITY', payload: { productId, quantity } }) }
  const getCartTotal = () => { return cart.reduce((total, item) => total + item.price * item.quantity, 0) }

  return (
    <CartContext.Provider value={{ cart, addToCart, removeFromCart, updateQuantity, clearCart, getCartTotal }}>
      {children}
    </CartContext.Provider>
  )
}

CartProvider.propTypes = { children: PropTypes.node.isRequired }

export const useCart = () => useContext(CartContext)
